// Variant pickers for the Recommended / Add-ons product blocks on the PDP.
// Loaded from cw-addon-sec and product-tabs; each block is initialised only once.
(function () {
  function parseVariantOptions(option) {
    try {
      return JSON.parse(option.getAttribute('data-variant-options'));
    } catch (e) {
      return null;
    }
  }

  // Show the variant's own image; fall back to the product image when the variant has none
  function updateAddonImage(image, variant) {
    if (!image.dataset.defaultSrc) {
      image.dataset.defaultSrc = image.getAttribute('src') || '';
      image.dataset.defaultAlt = image.getAttribute('alt') || '';
    }

    const src = variant.dataset.image || image.dataset.defaultSrc;
    const alt = variant.dataset.image ? variant.dataset.imageAlt || image.dataset.defaultAlt : image.dataset.defaultAlt;

    if (src && image.getAttribute('src') !== src) image.setAttribute('src', src);
    image.setAttribute('alt', alt);
  }

  // Each dropdown after the first lists only values that form a real variant with the
  // values chosen before it, so non-existent combinations can't be selected.
  function syncOptionValues(optionSelectors, variants) {
    optionSelectors.forEach((select, index) => {
      // Remember the full value list once; options are rebuilt from it
      if (!select.addonValues) {
        select.addonValues = Array.from(select.options).map((option) => ({
          value: option.value,
          text: option.textContent.trim(),
        }));
      }
      if (index === 0) return;

      const previous = optionSelectors.slice(0, index).map((selector) => selector.value);
      const matching = variants.filter((variant) => previous.every((value, i) => variant.options[i] === value));
      const allowed = new Set(matching.map((variant) => variant.options[index]));
      if (!allowed.size) return;

      const values = select.addonValues.filter((option) => allowed.has(option.value));
      const current = select.value;
      const changed =
        values.length !== select.options.length || values.some((option, i) => select.options[i].value !== option.value);
      if (changed) select.replaceChildren(...values.map((option) => new Option(option.text, option.value)));

      if (allowed.has(current)) {
        select.value = current;
      } else {
        // Previous choice no longer exists: prefer a value that is in stock
        const fallback = matching.find((variant) => variant.available) || matching[0];
        select.value = fallback.options[index];
      }
    });
  }

  function updateAddonVariant(block) {
    const optionSelectors = Array.from(block.querySelectorAll('.single-option-selector'));
    const masterSelector = block.querySelector('.product-variant-selector');
    if (!masterSelector) return;

    const variants = Array.from(masterSelector.options)
      .map((option) => ({ option, options: parseVariantOptions(option), available: option.dataset.available === 'true' }))
      .filter((variant) => Array.isArray(variant.options));
    syncOptionValues(optionSelectors, variants);

    const idInput = block.querySelector('input.product-variant-id');
    const priceDisplay = block.querySelector('.variant-price');
    const skuDisplay = block.querySelector('.variant-sku');
    const atcButton = block.querySelector('.product-form__submit');
    const atcLabel = block.querySelector('.atc-span');
    const image = block.querySelector('.rpb-image img');

    // Find the variant that matches the selected options
    const selectedOptions = JSON.stringify(optionSelectors.map((selector) => selector.value));
    const match = variants.find((entry) => JSON.stringify(entry.options) === selectedOptions);
    const variant = match ? match.option : null;
    const available = Boolean(variant) && variant.dataset.available === 'true';

    if (variant) {
      // Both the hidden input and the hidden select are named "id", keep them in sync
      masterSelector.value = variant.value;
      if (idInput) idInput.value = variant.value;
      if (priceDisplay) {
        priceDisplay.innerHTML = variant.dataset.price;
        priceDisplay.style.color = '';
      }
      if (skuDisplay) skuDisplay.textContent = variant.dataset.sku;
      if (image) updateAddonImage(image, variant);
    } else {
      if (priceDisplay) {
        priceDisplay.innerHTML = 'Unavailable';
        priceDisplay.style.color = 'red';
      }
      if (skuDisplay) skuDisplay.textContent = '';
    }

    if (!atcButton) return;

    atcButton.disabled = !available;
    // Grey out for out-of-stock and non-existent combinations
    atcButton.classList.toggle('unavailableBtn', !available);

    // Showroom Only / Trade Only labels are fixed and must not be overwritten
    if (atcLabel && atcButton.dataset.locked !== 'true') {
      if (!variant) {
        atcLabel.textContent = 'Unavailable';
      } else if (available) {
        atcLabel.textContent = atcButton.dataset.addText;
      } else {
        atcLabel.textContent =
          variant.dataset.discontinued === 'true' ? 'Discontinued' : atcButton.dataset.soldOutText;
      }
    }
  }

  function initAddonVariantPickers() {
    document.querySelectorAll('.required-product-block').forEach((block) => {
      if (block.dataset.addonPickerInit) return;
      block.dataset.addonPickerInit = 'true';

      block.querySelectorAll('.single-option-selector').forEach((selector) => {
        selector.addEventListener('change', () => updateAddonVariant(block));
      });

      updateAddonVariant(block);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAddonVariantPickers);
  } else {
    initAddonVariantPickers();
  }
})();
